import { DashboardNodeComponent } from './dashboard-node.component';
import {
  AfterViewInit,
  Directive,
  EventEmitter,
  QueryList,
  ViewChildren,
  ViewContainerRef,
} from '@angular/core';
import { ViewSelector } from './dom.constant';
import { Layout } from '../core/dashboard.node';

@Directive()
export abstract class LayoutComponent
  extends DashboardNodeComponent<Layout>
  implements AfterViewInit
{
  @ViewChildren(ViewSelector.CONTAINER, { read: ViewContainerRef })
  public containers!: QueryList<ViewContainerRef>;
  public readonly onViewInit = new EventEmitter();

  ngAfterViewInit(): void {
    this.afterLayoutInit();
    this.onViewInit.emit();
    this.onViewInit.emit();
    this.onViewInit.emit();
    this.onViewInit.emit();
  }

  abstract afterLayoutInit(): void;
}
